import { useDispatch } from "react-redux";
import "./App.css";
import RouteConfig from "./RouteConfig";
import LoadingMask from "./components/LoadingMask/LoadingMask";
import { Toaster } from "react-hot-toast";
import { useEffect } from "react";
import ConfirmBox from "./components/Common/ConfirmBox/Confirmbox";
import { getValidAccessToken } from "./Services/oauthServices";
import { useTranslation } from "react-i18next";
import axios from "axios";
import BlockBrowserBack from "./BlockBrowserBack";

function App() {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();

  useEffect(() => {
    const interceptorId = axios.interceptors.request.use((config) => {
      const requestUrl = config.url || "";
      const apiBaseUrl = process.env.REACT_APP_API_URL || "";
      const shouldAttachCurrentUrl =
        requestUrl.startsWith("/") || requestUrl.startsWith(apiBaseUrl);

      if (typeof window !== "undefined" && shouldAttachCurrentUrl) {
        config.headers = {
          ...config.headers,
          "X-Current-Url": window.location.href,
        };
        config.withCredentials = false;
      }
      return config;
    });

    return () => {
      axios.interceptors.request.eject(interceptorId);
    };
  }, []);

  useEffect(() => {
    const initApp = async () => {
      await getValidAccessToken();

      dispatch({ type: "domain/checkDomain" });

      // const partnerId = await fetchPartnerConfigInBackground();
      // await fetchPartnerSmsConfig(partnerId);

      // setIsloading(false);
    };

    initApp();
  }, [dispatch]);

  useEffect(() => {
    document.body.dir = i18n.dir();
  }, [i18n.language]);

  return (
    <>
      <ConfirmBox />
      <LoadingMask />
      <BlockBrowserBack />
      <RouteConfig />
      <Toaster position="top-center" reverseOrder={false} />
    </>
  );
}

export default App;
